import React from "react";

export function Button({ children, variant = "default", size = "default", className = "", ...props }) {
  // Base classes with minimum tap target size (48x48px) for mobile accessibility
  const baseClasses = "inline-flex items-center justify-center rounded font-medium transition-all focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus-visible:ring-4 min-h-[48px]";
  
  const variantClasses = {
    default: "bg-blue-600 text-white hover:bg-blue-700 motion-safe:hover:scale-[1.02]",
    primary: "bg-blue-600 text-white hover:bg-blue-700 active:bg-blue-800 shadow-md hover:shadow-lg focus:ring-blue-500 motion-safe:hover:scale-[1.02]",
    secondary: "border-2 border-gray-300 bg-white text-gray-700 hover:bg-gray-50 hover:border-gray-400 focus:ring-gray-400",
    outline: "border border-gray-300 bg-white text-gray-700 hover:bg-gray-50",
    ghost: "bg-transparent text-gray-700 hover:bg-gray-100"
  };

  // Size classes with mobile-friendly tap targets
  const sizeClasses = {
    default: "px-6 py-3 text-base",
    sm: "px-4 py-2 text-sm min-h-[44px]", // Slightly smaller but still acceptable
    lg: "px-8 py-4 text-lg min-h-[56px]"
  };

  const classes = `${baseClasses} ${variantClasses[variant] || variantClasses.default} ${sizeClasses[size] || sizeClasses.default} ${className}`;
  
  return (
    <button {...props} className={classes}>
      {children}
    </button>
  );
}
